import { Users, Cake, Calendar, CalendarCheck, Heart, CreditCard } from 'lucide-react';
import TabGrid from '@/components/ui/TabGrid';

/**
 * Important Dates Tab Configuration
 * Calming pastels for life events
 */
const TAB_CONFIG = [
  {
    id: 'family',
    label: 'Network',
    icon: Users,
    colors: {
      bg: '#E2EDE6',
      active: '#C8DED0',
      text: '#22543D',
      iconBg: '#D5E5DB',
    }
  },
  {
    id: 'birthday',
    label: 'Birthdays',
    icon: Cake,
    colors: {
      bg: '#FCE4EC',
      active: '#F8BBD9',
      text: '#AD1457',
      iconBg: '#FACCE1',
    }
  },
  {
    id: 'appointment',
    label: 'Appointments',
    icon: Calendar,
    colors: {
      bg: '#EDE9F6',
      active: '#DCD4EE',
      text: '#5B4B8A',
      iconBg: '#E2DBEF',
    }
  },
  {
    id: 'reservation',
    label: 'Reservations',
    icon: CalendarCheck,
    colors: {
      bg: '#DBEAFE',
      active: '#BFDBFE',
      text: '#1E40AF',
      iconBg: '#CEE5FD',
    }
  },
  {
    id: 'community',
    label: 'Community',
    icon: Heart,
    colors: {
      bg: '#FEE8DC',
      active: '#FDDACA',
      text: '#9C4221',
      iconBg: '#FDE0D0',
    }
  },
  {
    id: 'membership',
    label: 'Memberships',
    icon: CreditCard,
    colors: {
      bg: '#D5F5F6',
      active: '#B2EBEC',
      text: '#0F766E',
      iconBg: '#C4F0F1',
    }
  }
];

/**
 * DatesTabs - Grid-based tab navigation for Important Dates module
 * All tabs visible at once - no scrolling, no hidden features
 */
const DatesTabs = ({ activeTab, onTabChange, children }) => {
  return (
    <TabGrid
      tabs={TAB_CONFIG}
      activeTab={activeTab}
      onTabChange={onTabChange}
      testIdPrefix="dates-tab"
    >
      {children}
    </TabGrid>
  );
};

export { TAB_CONFIG };
export default DatesTabs;
